/* Vertrouwensbalk: op een telefoon schuiven de beloftes om de paar seconden door.

   Gebouwd 2026-09-03 op verzoek van Stijn. Daarvoor verdwenen op een smal scherm drie
   van de vier regels met een display:none — er was simpelweg geen plek voor vier
   naast elkaar. Nu blijven ze alle vier bestaan en krijgt elke regel om de beurt het
   woord.

   Alleen op smalle schermen. Op desktop staan ze naast elkaar en is doorschuiven
   alleen maar onrustig; daar doet dit bestand niets.

   De bezorgklok blijft ondertussen gewoon lopen in de regels die je even niet ziet:
   die worden niet uit de pagina gehaald, alleen doorzichtig gemaakt. Zo staat de klok
   meteen goed zodra hij weer aan de beurt is. */

(function () {
  var WISSELTIJD = 4000;
  var GRENS = '(max-width: 749px)';

  var balk = document.querySelector('.vtb__binnen');
  if (!balk) return;

  var items = Array.prototype.slice.call(balk.querySelectorAll('.vtb__item'));
  if (items.length < 2) return;

  var huidig = 0;
  var teller = null;
  var media = window.matchMedia(GRENS);

  function toon(i) {
    items.forEach(function (el, n) {
      el.classList.toggle('vtb__item--actief', n === i);
      /* Uit de voorleesvolgorde halen wat niet zichtbaar is, anders leest een
         schermlezer vier regels door elkaar. */
      el.setAttribute('aria-hidden', n === i ? 'false' : 'true');
    });
  }

  function volgende() {
    huidig = (huidig + 1) % items.length;
    toon(huidig);
  }

  function start() {
    if (teller) return;
    balk.classList.add('vtb__binnen--roulerend');
    huidig = 0;
    toon(huidig);
    teller = setInterval(volgende, WISSELTIJD);
  }

  function stop() {
    if (teller) {
      clearInterval(teller);
      teller = null;
    }
    balk.classList.remove('vtb__binnen--roulerend');
    items.forEach(function (el) {
      el.classList.remove('vtb__item--actief');
      el.removeAttribute('aria-hidden');
    });
  }

  function bepaal() {
    if (media.matches) {
      start();
    } else {
      stop();
    }
  }

  /* Wie zijn systeem op "minder beweging" heeft staan, krijgt geen wisselende regels.
     Dan blijft de eerste staan; dat is nog altijd beter dan drie verborgen regels. */
  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (rustig.matches) {
    balk.classList.add('vtb__binnen--roulerend');
    toon(0);
    return;
  }

  bepaal();
  if (media.addEventListener) {
    media.addEventListener('change', bepaal);
  } else if (media.addListener) {
    media.addListener(bepaal);
  }

  /* Niet doorschuiven als het tabblad op de achtergrond staat: dan mist iemand bij
     terugkomst het halve rijtje. */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (teller) {
        clearInterval(teller);
        teller = null;
      }
    } else if (media.matches && !teller) {
      teller = setInterval(volgende, WISSELTIJD);
    }
  });
})();
